export enum WidthConstraint {
  WIDTH_CONSTRAINT_UNKNOWN = 'WIDTH_CONSTRAINT_UNKNOWN',
  FULL_WIDTH = 'FULL_WIDTH',
  THREE_QUARTERS_WIDTH = 'THREE_QUARTERS_WIDTH',
  TWO_THIRDS_WIDTH = 'TWO_THIRDS_WIDTH',
}
